export class WellsModel {
    wellName: string;
    wellType: string;
    basin: string;
    status: string;
    target: string;
    sortOrder: number;
}